import { useLazyQuery } from '@apollo/client';
import type {
  AudienceSegmentSetMetrics,
  CalculateOrfSegmentMetricsInput,
  NormalizedDefinitionInput,
} from '@openx/types/gqlTypes';
import { useCallback, useState } from 'react';
import { GetCalculateOrfDocument } from '../../../graphql/query/dealPrompt/GetCalculateOrf.generated';

export const useDealPromptAudienceCalculateOrf = () => {
  const [loading, setLoading] = useState(false);
  const [fetchCalculateOrf] = useLazyQuery(GetCalculateOrfDocument);

  const calculateOrf = useCallback(
    async ({
      segmentIds,
      normalizedDefinition,
      segmentMetrics,
    }: {
      segmentIds: string[];
      normalizedDefinition: NormalizedDefinitionInput;
      segmentMetrics: CalculateOrfSegmentMetricsInput[];
    }) => {
      setLoading(true);
      try {
        const result = await fetchCalculateOrf({
          variables: {
            input: { segmentIds, normalized_definition: normalizedDefinition, segmentMetrics },
          },
        });
        if (result.error) {
          throw result.error;
        }
        return result.data?.calculateOrf as AudienceSegmentSetMetrics | undefined;
      } finally {
        setLoading(false);
      }
    },
    [fetchCalculateOrf]
  );

  return { calculateOrf, loading };
};
